import { useEffect, useMemo, useState } from 'react';
import { excel } from './lib';

export function useDownloadExcel({ currentTableRef, filename, sheet }) {
  const [payload, setPayload] = useState({});

  useEffect(() => {
    setPayload({
      currentTableRef,
      filename,
      sheet,
    });
  }, [currentTableRef, filename, sheet]);

  return useMemo(() => excel(payload), [payload]);
}
